const initial = {};

export default (state = initial, action = {}) => {
  switch (action.type) {
    case 'SCORES_SET':
      return action.payload;
    default:
      return state;
  }
};
